// Phone-event tracking, ported from akkusegely.hu's PhoneSupport() and aligned
// with akkubolt's utils/phoneShow.ts:
// - a first-party server ping that is NOT consent-gated — it only feeds the
//   internal statistics table and the admin's call-source attribution (no
//   cookies, no third party), exactly like set_vs/get_phone_show on the PHP
//   sites. GET /api/phone_show hits akku-24's own _ajax.php proxy, which calls
//   API::Get('/phone_show'); the API stamps visitor_session_info.phone_show_datetime
//   (+ the durable visitor_session_utm mirror) on THIS visitor's session and
//   fires SendGAEvent('Phone','Show','A2') server side. That timestamp is what
//   the admin's AdminOrderStart reads to auto-suggest the caller's traffic
//   source ("Honnan ismer minket?") inside its 3-minute window.
// - a GA4 event on the site property (G-3FCGS1X7N8) that IS gated on the
//   TermsFeed `tracking` consent level, matching GASend() on the PHP sites.
//   Event names use the network's Category_Action convention (Phone_Show /
//   Phone_Call) so cross-property reports line up.
import apiClient from '../api/client';
import { gaTrackEvent as gaEvent } from './analytics';

// One reveal per page load. visitor_session_info.phone_show_datetime records a single
// "this visitor asked for the number" moment, so a second click (header after footer,
// or vice versa) must not fire a second beacon.
let notified = false;

export function notifyPhoneShow(): void {
	if (notified) return;
	notified = true;

	gaEvent('Phone_Show');

	// Fire-and-forget: a failed beacon must never block revealing the number.
	apiClient.get('/phone_show').catch(() => {});
}

/**
 * A tel: link was tapped → the visitor is dialing. Same chain as akkubolt's
 * notifyPhoneCall and the PHP sites' SetVS({phone_call: 1}): the visitor_session
 * beacon fires SendGAEvent('Phone','Call','A2') server side, which records the
 * Phone_Call statistics row on THIS visitor's session. No page-load guard —
 * unlike the reveal, every dial attempt is a distinct signal.
 */
export function notifyPhoneCall(): void {
	gaEvent('Phone_Call');

	apiClient.post('/visitor_session', { phone_call: 1 }).catch(() => {});
}
